module.exports = __webpack_public_path__ + "static/media/TERMO_DE_USO_PORTAL_DE_FORNECEDORES_05.11.2019.02000b88.pdf";